import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function ThankYou() {
  return (
    <div data-testid="page-thankyou" className="min-h-[70vh] flex items-center justify-center px-6 py-24">
      <div className="max-w-2xl text-center">
        <div className="h-16 w-16 rounded-full bg-[#E6F6EC] flex items-center justify-center mx-auto mb-6">
          <CheckCircle2 className="h-8 w-8 text-[#00A651]" />
        </div>
        <h1 className="text-4xl md:text-5xl font-extrabold tracking-tighter text-[#1F1E4E]">Thank you!</h1>
        <p className="mt-4 text-lg text-slate-600 leading-relaxed">
          We've received your request. An HR specialist from ClockedIn HRM will reach out within 1 business day to schedule your session.
        </p>
        <div className="mt-8 flex justify-center gap-3 flex-wrap">
          <Link to="/features" data-testid="ty-explore-btn" className="bg-[#00A651] hover:bg-[#008A43] text-white font-bold rounded-lg px-6 py-3">Explore Features</Link>
          <Link to="/" className="border-2 border-[#1F1E4E] text-[#1F1E4E] font-bold rounded-lg px-6 py-3">Back to Home</Link>
        </div>
      </div>
    </div>
  );
}
